export default __webpack_public_path__ + "static/media/Facebook_White.e5892df2.svg";